import Head from 'next/head';

import { SITE_ORIGIN } from '@/constants/site';

function normalizePath(path: string) {
  if (!path) {
    return '/';
  }

  return path.startsWith('/') ? path : `/${path}`;
}

export interface PageHeadProps {
  canonical?: string;
  description?: string;
  path: string;
  robots?: string;
  title: string;
}

export function PageHead({
  canonical,
  description,
  path,
  robots = 'index, follow',
  title,
}: PageHeadProps) {
  const normalizedPath = normalizePath(path);
  const url = `${SITE_ORIGIN}${normalizedPath === '/' ? '' : normalizedPath}`;
  const canonicalUrl = `${SITE_ORIGIN}${normalizePath(canonical)}`;

  return (
    <Head>
      <title>{title}</title>

      {description && <meta content={description} key="description" name="description" />}
      <meta content={title} key="og:title" property="og:title" />
      {description && <meta content={description} key="og:description" property="og:description" />}
      <meta content={url} key="og:url" property="og:url" />

      <meta content={title} key="twitter:title" name="twitter:title" />
      <meta content={description} key="twitter:description" name="twitter:description" />

      <link href={canonical ? canonicalUrl : url} key="canonical" rel="canonical" />
      <meta content={robots} key="robots" name="robots" />
    </Head>
  );
}
